import React from 'react';
import core from '@enigma/core';
import { user as AppUser, firestore } from '@enigma/core/services';
import util from '@enigma/core/utilities';
import { useEffect, useState } from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import Stylesheet from './App.module.css';
// App Context
import { UserContext } from '../../contexts/user';
import { AppContext } from '../../contexts/app';
// Cross-Page Components
import Loading from '../../components/Spinner/Standard/Standard';
import Popup from '../../components/Popup/Popup';
import MessageBox from '../../components/MessageBox/MessageBox';
import Notification from '../../components/Message/notification';
import Toast from '../../components/Toast/toast';
import Modal from '../../components/Modal/Modal';
import Dashboard from '../Dashboard/Dashboard';
// App Pages
import Login from '../../pages/Login/Login';
import Register from '../../pages/Register/Register';
import { ico_envelope, ico_database, ico_bell } from '../../icon';

function App() {
  // application states
  const [user, setUser] = useState({ profile: null });
  const [noticiations, setNotifications] = useState([])
  const [loggedOut, setLoggedOut] = useState(false);
  useEffect(() => core.init({
    apiKey: "AIzaSyC2yMNg6Qj_itIswjhhc6pO0RF2SbsvKko",
    authDomain: "gmgroupfj.firebaseapp.com",
    databaseURL: "https://gmgroupfj-default-rtdb.firebaseio.com",
    projectId: "gmgroupfj",
    storageBucket: "gmgroupfj.appspot.com",
    messagingSenderId: "1015367804161",
    appId: "1:1015367804161:web:bdfe623bd9696379d7e700",
    measurementId: "G-8WM196MXPK"
  }), [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => AppUser.onAuthChange(onAppAuthChange), [])
  // app-level component
  const [popup, setPopup] = useState(null);
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);
  const [notification, setNotification] = useState(null);
  const [messageBox, setMessageBox] = useState(null);
  // app-level component triggers
  const toggleMenu = () => {
    let appConfig = { ...app };
    appConfig.config.dockedMenu = app.config.dockedMenu ? false : true;
    setApp(appConfig);
  }
  const toggleTheme = (preset = 'light' || 'dark' || 'high-contrast') => {
    let appConfig = { ...app };
    appConfig.config.theme = preset;
    setApp(appConfig);
  }
  const togglePopup = (icon = null, content = null, title = null) => {
    setPopup({ icon: icon, content: content, title: title, show: popup?.show ? false : true })
  }
  const toggleModal = (icon = null, content = null, title = null) => {
    setModal({ icon: icon, content: content, title: title, show: modal?.show ? false : true });
  }
  const toggleToast = (icon = null, text = null, isError = false) => {
    setToast({ icon: icon, text: text, isError: isError, show: toast?.show ? false : true })
    const delay = setTimeout(() => {
      clearTimeout(delay);
      setToast({ icon: icon, text: text, isError: isError, show: false })
    }, 3000);
  }
  const toggleNotification = (icon = null, text = null, description = null, url = null) => {
    setNotification({ icon: icon, text: text, description: description, url: url, show: notification?.show ? false : true })
    const delay = setTimeout(() => {
      clearTimeout(delay);
      setNotification({ icon: icon, text: text, description: description, url: url, show: false })
    }, 3000);
  }
  const toggleMessageBox = (title = null, content = null, type = null) => {
    return new Promise((resolve, reject) => {
      const payload = {
        title: title, content: content, type: type,
        show: messageBox?.show ? false : true,
        value: messageBox?.show ? null : messageBox?.value,
        onReturn: function (value) {
          resolve(value);
        }
      };
      // show message box
      setMessageBox(payload);
    })
  }
  // attach listner for notifications
  useEffect(() => {
    if (!user.profile) return;
    // show notify notifications due within 1 month from now
    const maxThreshold = new util.cdate();
    maxThreshold.incrementDay(30);
    // close notiy notifications 7 days prior
    const minThreshold = new util.cdate();
    minThreshold.decrementDay(7);
    // generate notifications listner
    let query = firestore.collection('notifications')
      .where('branch', "==", user.profile.branch)
      .where('due', "<=", maxThreshold.dateObject.getTime())
      .where('due', ">=", minThreshold.dateObject.getTime());
    if (user.profile?.admin) {
      query = firestore.collection('notifications')
        .where('due', "<=", maxThreshold.dateObject.getTime())
        .where('due', ">=", minThreshold.dateObject.getTime());
    }
    // set notify notifications
    const lisnter = query.onSnapshot(snap => {
      let collection = [];
      for (const document of snap.docs)
        collection.push({ ...document.data(), id: document.id })
      // show notifications popup
      if (collection.length !== notification?.length && collection.length !== 0)
        toggleNotification(ico_bell, "new notifications",
          "there are a few notifications to review", 'account/noticiations');
      setNotifications([...collection]);
    })
    // set user notifications
    //UserNotifications.
    // detach lisnter
    return function cleanup() { lisnter() }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])
  // fetch user custom configuration
  const [app, setApp] = useState({
    config: { dockedMenu: false, theme: 'light' },
    toggleMenu: toggleMenu,
    toggleTheme: toggleTheme,
    toggleToast: toggleToast,
    toggleMessageBox: toggleMessageBox,
    toggleModal: toggleModal,
    togglePopup: togglePopup
  });
  const onAppAuthChange = async (user) => {
    // update user context
    if (user) {
      const profile = await AppUser.getProfile();
      if (!profile)
        // user profile does not exist, 
        // user may have been removed
        await AppUser.delete();
      else {
        // request system notification privilages
        // if (!util.notifications.isNotificationPermissionGranted) {
        //   await util.notifications.requestPermission();
        // }
      }
      // update user context
      setUser({ profile: profile });
      if (!AppUser.isEmailVerified)
        app.toggleToast(ico_envelope, "your email is not verified, some features will be disabled.", true);
    } else setUser({ profile: null });
  }

  // load resources
  if (!user?.profile && !loggedOut) {
    // wait for auto login
    let loading = setTimeout(() => {
      clearTimeout(loading);
      if (!user?.profile) setLoggedOut(true);
    }, 7000);
    return (
      <div className={Stylesheet.Container}>
        <div className={Stylesheet.Loading}>
          <h1>{ico_database}</h1>
          <div className={Stylesheet.Spinner}>
            <Loading show={true} />
          </div>
        </div>
      </div>
    )
  }
  return (
    <UserContext.Provider value={user}>
      <AppContext.Provider value={{ ...app, profile: user.profile, notifications: noticiations }}>
        <Router>
          <Toast show={toast?.show} icon={toast?.icon}
            isError={toast?.isError} onClose={toggleToast}>
            {toast?.text}</Toast>
          <Notification show={notification?.show} icon={notification?.icon}
            text={notification?.text}
            description={notification?.description} url={notification?.url}
            onClose={toggleNotification}>
            {toast?.text}</Notification>
          <Popup show={popup?.show} icon={popup?.icon}
            onClose={togglePopup} title={popup?.title}>
            {popup?.content}</Popup>
          <MessageBox show={messageBox?.show}
            title={messageBox?.title} onReturn={messageBox?.onReturn}
            onClose={toggleMessageBox} content={messageBox?.content}
            type={messageBox?.type} />
          <Modal show={modal?.show} icon={modal?.icon}
            onClose={toggleModal} title={modal?.title}
            content={modal?.content} />
          <Switch>
            <Route exact path='/login' component={Login} />
            <Route exact path='/register' component={Register} />
            <Route>{user.profile ? <Dashboard /> : <Redirect to='/login' />}</Route>
          </Switch>
        </Router>
      </AppContext.Provider>
    </UserContext.Provider>
  )
}

export default App;
